import { withJsonFormsControlProps } from "@jsonforms/react";
import { Button as MuiButton, Popover } from "@mui/material";
import { Button, TextInput } from "pepsico-ds";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import "./rangeFilter.scss";

const RangeFilterComponent = (props) => {
  const { data, handleChange, path, label, uischema } = props;
  const options = uischema.options || {};
  const buttonLabel = options.buttonLabel || label || "Set Range";
  const fromLabel = options.fromLabel || "From";
  const toLabel = options.toLabel || "To";
  const fromPlaceholder = options.fromPlaceholder || "Select From";
  const toPlaceholder = options.toPlaceholder || "SelectTo";
  const [anchorEl, setAnchorEl] = useState(null);
  const [fromValue, setFromValue] = useState(data?.from || "");
  const [toValue, setToValue] = useState(data?.to || "");
  const open = Boolean(anchorEl);

  useEffect(() => {
    setFromValue(data?.from ?? "");
    setToValue(data?.to ?? "");
  }, [data]);

  const handleButtonClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const handleApply = () => {
    let parsedFromValue = fromValue === "" ? null : parseInt(fromValue, 10);
    let parsedToValue = toValue === "" ? null : parseInt(toValue, 10);

    if (isNaN(parsedFromValue)) {
      parsedFromValue = null;
    }
    if (isNaN(parsedToValue)) {
      parsedToValue = null;
    }

    handleChange(path, { from: parsedFromValue, to: parsedToValue });
    setAnchorEl(null);
  };
  const handleClear = () => {
    setFromValue("");
    setToValue("");
    handleChange(path, { from: null, to: null });
    setAnchorEl(null);
  };
  const hasValue =
    (fromValue !== "" && fromValue !== null && fromValue !== undefined) ||
    (toValue !== "" && toValue !== null && toValue !== undefined);

  const buttonVariant = hasValue ? "contained" : "outlined";

  const handleKeyDown = (e) => {
    // Block certain keys: e/E, +, and - (if you only want positive numbers)
    if (["e", "E", "+", "-"].includes(e.key)) {
      e.preventDefault();
    }
  };
  return (
    <div className="range-filter">
      <MuiButton variant={buttonVariant} onClick={handleButtonClick} size="small">
        {buttonLabel}
      </MuiButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        PaperProps={{ className: "range-filter-popover" }}
      >
        <div className="popover-content">
          <div className="input-container">
            <TextInput
              label={fromLabel}
              type="number"
              value={fromValue}
              placeholder={fromPlaceholder}
              onChange={(e) => setFromValue(e.target.value)}
              fullWidth
              margin="normal"
              onKeyDown={handleKeyDown}
              InputProps={{
                inputProps: { min: 0 },
                sx: {
                  padding: "0px 0px", // Reduce padding inside the input
                  fontSize: "small", // Smaller font size
                },
              }}
            />
            <TextInput
              label={toLabel}
              type="number"
              value={toValue}
              placeholder={toPlaceholder}
              onChange={(e) => setToValue(e.target.value)}
              fullWidth
              margin="normal"
              onKeyDown={handleKeyDown}
              InputProps={{
                inputProps: { min: 0 },
                sx: {
                  padding: "0px 0px", // Reduce padding inside the input
                  fontSize: "small", // Smaller font size
                },
              }}
            />
          </div>
          <div className="icon-container">
            <Button onClick={handleClear} variant="secondary" size="small">
              Cancel
            </Button>
            <Button onClick={handleApply} variant="primary" size="small">
              Save
            </Button>
          </div>
        </div>
      </Popover>
    </div>
  );
};

RangeFilterComponent.propTypes = {
  data: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  label: PropTypes.string,
  uischema: PropTypes.object.isRequired,
};

export const RangeFilterControl = withJsonFormsControlProps(RangeFilterComponent);
